import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SubdomainInputComponent } from '../../subdomain-input/subdomain-input.component';
import type { DynamicSubdomainInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class DynamicSubdomainInput extends DynamicFormInput<DynamicSubdomainInputConfig> {}

@Component({
  selector: 'rti-subdomain-input-adapter',
  template: `<rti-subdomain-input
    [formControl]="input.control"
    [suffix]="input.config.suffix"
    [prefix]="input.config.prefix"
  ></rti-subdomain-input>`,
  imports: [SubdomainInputComponent, ReactiveFormsModule],
})
export class DynamicSubdomainInputComponent {
  @Input() public input: DynamicSubdomainInput;
}
